import styled from "styled-components";
import DatepickerIcon from "../Assets/Icons/date-picker.svg";
import userAvatar from "../Assets/Icons/user.svg";

export const GlobalSet = styled.div`
  text-align: right;
  .ant-btn.textTypeBtnERP.erp-btn {
      line-height: 1.5715;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 0px solid transparent;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation;
    height: 14px;
    padding-bottom:2px;
    padding: 0px 2px;
    font-size: 14px;
    border-radius: 2px;
    color: rgba(0, 0, 0, 0.85);
    border-color: #d9d9d9;
    background: #fff;
    }
  .textTypeBtnERP span {
    font-size: 12px;
    font-family: var(--sf-pro-display);
    color: #ea655b;
    line-height: 16px;
    text-align: center;
    margin-left: 10px;
    position: relative;
    top: -1px;
  }
  .textTypeBtn span {
    font-size: 14px;
    font-family: var(--sf-pro-display);
    color: #ea655b;
    line-height: 16px;
    text-align: center;
    margin-left: 10px;
    position: relative;
    top: -1px;
  }
  button.ant-btn.textTypeBtn.btn span {
    &:after {
      color: var(--theme-color-hover) !important;
      svg {
        border: none;
      }
    }
  }
  button.ant-btn.textTypeBtnERP.btn span {
    &:after {
      color: var(--theme-color-hover) !important;
      svg {
        border: none;
      }
    }
  }
  button.ant-switch.switch-new.ant-switch-checked {
    background-color: var(--theme-color) !important;
  }
  .ant-switch {
    background: #6b778c;
  }
  .ant-switch.switch-new .ant-switch-handle::before {
    top: 0.5px !important;
  }
  .ant-btn.textTypeBtn.edit-btn {
    top: 5px;
    right: 8px;
  }
  button.ant-btn.textTypeBtn.edit-btn {
    padding: 7px 7px;
  }
  button.ant-btn.textTypeBtn.edit-btn:hover {
    background-color: #f3f2f1;
    line-height: 1;
    border-radius: 8px;
    &:after {
      display: none;
    }
  }
  button.ant-btn.textTypeBtnERP.edit-btn:hover {
    background-color: #f3f2f1;
    line-height: 1;
    border-radius: 8px;
    &:after {
      display: none;
    }
  }

  button.ant-btn.textTypeBtn.textBtnIcon:after {
    display: none;
  }
  button.ant-btn.textTypeBtnERP.textBtnIcon:after {
    display: none;
  }

  .textTypeBtn.textBtnIcon span {
    &:after {
      content: "";
      position: absolute;
      bottom: -3px;
      left: 0px;
      width: 100%;
      height: 1px;
      background-color: var(--theme-color-hover);
      opacity: 0;
      transition: all 0.3s linear;
    }
    &:hover {
      color: var(--theme-color-hover);
      &:after {
        opacity: 1;
      }
    }
  }
    .textTypeBtnERP.textBtnIcon span {
    &:after {
      content: "";
      position: absolute;
      bottom: -3px;
      left: 0px;
      width: 100%;
      height: 1px;
      background-color: var(--theme-color-hover);
      opacity: 0;
      transition: all 0.3s linear;
    }
    &:hover {
      color: var(--theme-color-hover);
      &:after {
        opacity: 1;
      }
    }
  }
  .checklist-address {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    align-self: center !important;
    margin-bottom: 15px;
    p {
      font-size: 16px;
      font-family: var(--sf-pro-display);
      padding-left: 14px;
      margin-bottom: 0;
      line-height: 16px;
      text-align: center;
      align-self: center !important;
    }
  }
  textarea.ant-input {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
    font-size: 14px;
    font-family: var(--sf-pro-text);
    color: #323130;
    box-shadow: none !important;
    overflow: hidden;
    border-right-width: 2px !important;
    resize: none;
  }
`;
export const DisabledStyles = styled.div`
  input.ant-input.ant-input-disabled.disabled-check {
    background-color: #f3f2f1 !important;
    border-color: #dfe1e6 !important;
  }
  .ant-select-disabled {
    background-color: #f3f2f1 !important;
    border-color: #dfe1e6 !important; 
  }
  .requestChangeValue {
    color: #091e42 !important;
  }
`;
export const DeliveryaddressSpacing = styled.div`
  .haberdeliveryaddress {
    .ant-row {
      &.ant-form-item {
        margin-bottom: 0 !important;
      }
    }
  }
`;
export const Styled = styled.div`
  .ant-tooltip-inner {
    padding: 7px !important;
    background: rgba(32, 31, 30, 0.85) !important;
    border-radius: 8px !important;
    font-family: var(--sf-pro-display-m);
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
  }
  .edit-tooltip .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
    top: 3px;
    right: 13px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ea655b !important;
    border-color: #dfe1e6 !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #ea655b !important;
  }
  .ant-checkbox-checked::after {
    border-color: #ea655b !important;
  }
`;

export const DatePickerY = styled.div`
  .ant-picker {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
    height: 40px;
    font-size: 14px;
    font-family: var(--sf-pro-text);
    color: #323130;
    box-shadow: none !important;
    overflow: hidden;
    border-right-width: 2px !important;
    width: 100%;
  }

  .anticon {
    display: none !important;
  }
  .ant-picker-suffix {
    width: 17px;
    height: 19px;
    background-image: url(${DatepickerIcon});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
export const StyledTab = styled.div`
  .ant-tabs-tab {
    font-family: var(--sf-pro-display-m) !important;
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
    color: #a19f9d;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--theme-color) !important;
    font-family: var(--sf-pro-display-m) !important;
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
  }
  .ant-tabs-tab:hover {
    color: var(--theme-color) !important;
  }
  .ant-tabs-ink-bar {
    background: var(--theme-color) !important;
  }
  .ant-tabs-tab-btn:focus,
  .ant-tabs-tab-remove:focus,
  .ant-tabs-tab-btn:active,
  .ant-tabs-tab-remove:active {
    color: var(--theme-color) !important;
  }
`;
export const DisabledButtonStyle = styled.div`
  align-self: center;
  .ant-btn.themeBtn.noBg.disabledstyle {
    border: 1px solid #f3f2f1 !important;
  }
  .disabledstyle svg {
    color: #a19f9d !important;
  }
  .disabledstyle span {
    color: #a19f9d !important;
  }
  .ant-btn.themeBtn.noBg.disabledstyle.approve-header {
    color: #605e5c !important;
  }
  // .ant-btn.themeBtn.noBg.disabledstyle.approve-header:hover{
  //   border: 1px solid #605E5C!important;
  // }

  .themeBtn.noBg.active {
    min-width: 90px;
    border-radius: 8px;
    padding: 4px 18px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    &.noBg {
      background-color: transparent;
      border: 1px solid var(--theme-color) !important;
      span {
        color: var(--theme-color);
      }
    }
  }
  .ant-btn.themeBtn.noBg.active svg {
    color: var(--theme-color) !important;
  }
  .ant-btn.themeBtn.noBg.approveAllOrders {
    border: 1px solid #605e5c !important;
    span {
      color: #605e5c !important;
    }
  }
`;
export const PaperHeaderButtonStyle = styled.div`
  .ant-btn.themeBtn.noBg.paperButtonnoBg {
    span {
      margin-left: 10px !important;
    }
    svg {
      width: 14px;
      height: 14px;
      margin-top: -5px;
    }
  }
  .ant-btn.textTypeBtn.textBtnIcon.paperButtonBg span {
    margin-left: 10px !important;
  }
  .ant-btn.themeBtn.noBg.paperButtonnoBg.disabled {
    border: none !important;
    background: #f3f2f1 !important;
    span {
      color: var(--light-text) !important;
    }
    svg {
      color: #a19f9d !important;
    }
  }
`;
export const PaperMachineRecordsData = styled.div`
.printCheckBoxStyle{
  .ant-checkbox-inner {
    position: relative;
    // right: 16px;
    top: 0;
    left: 0;
    width: 16px;
    height: 16px;
    display: block;
    direction: ltr;
    background: #ffffff;
    // border: 1px solid #c8c6c4;
    // box-sizing: border-box;
    // border-radius: 0px;
    border-radius: 2px;
    border-collapse: separate;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ea655b;
    border-color: #ea655b;
  }
  .ant-checkbox-checked::after {
    border: 1px solid #ea655b;
    display: none;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border: 1px solid #ea655b;
  }
  .ant-checkbox-inner::after {
    left: 2.5px;
    //height: 11.140px;
  }
  .ant-checkbox-input {
    position: absolute !important;
    opacity: 0;
    width: 90%;
    height:10px;
  }
  .ant-checkbox {
    position: static !important;
  }
}
.centerAlignBtn {
  button {
    align-self: center;
  }
  .deleteQtyBtn {
    margin: 0 !important;
    margin-left: 7px !important;
    right: 0px !important;
    top: 0 !important;
  }
}
  .switchRadio {
    &.threeSwitch {
      .ant-radio-group-solid {
        label {
          width: 126px;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }
    &.twoSwitch {
      .ant-radio-group-solid {
        flex-grow: 1;
        display: flex;
        label {
          flex-grow: 0.5;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }

    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
      background-color: transparent !important;
    }
    .ant-radio-group-solid
      .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
      box-shadow: none !important;
    }
    &.extraWidth {
      .ant-radio-group-solid {
        label {
          width: 200px;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }

    &.csvStyle {
      .ant-radio-group-solid {
        label {
          &:last-child {
            border: 0.5px solid;
          }
        }
      }
    }

    .ant-radio-group-solid {
      border-radius: 8px;
      overflow: hidden;
      border: 0px;
      label {
        width: 120px;
        height: 40px;
        margin: 0;
        border: 1px solid #e1dfdd;
        background-color: #ffff !important;
        &:first-child {
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
        &:last-child {
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          border-left: 0px;
          &:before {
            background-color: #a19f9d;
          }
        }
        &.ant-radio-button-wrapper-checked {
          background-color: #f3f2f1 !important;
          border-color: #a19f9d;
          span {
            color: #605e5c !important;
          }
        }
        span:last-child {
          font-style: normal;
          color: #a19f9d;
          font-family: var(--sf-pro-text);
          text-align: center;
          display: table;
          margin: 0px auto;
          padding: 4px 0;
        }
      }
    }
  }
  .ant-radio-button-wrapper:focus-within {
    box-shadow: none;
  }
  .switchRadio .ant-radio-group-solid label.ant-radio-button-wrapper-checked span {
    color: rgb(96, 94, 92) !important;
}

.groupDetailWrap {
  .ant-row {
    input[type="text"],
    input[type="password"] {
      padding-left: 15px !important;
    }
    &.ant-form-item {
      margin-bottom: 0px;
    }
  }
  .centerAlign {
    align-self: center;
    width: 100%;
    // border-bottom: 1px solid #edebe9;
    padding: 16px 0;
    > div {
      display: flex;
    }
    &:last-child {
      border-bottom: 0px;
    }
  }
}

.groupForm {
  // border-bottom: 1px solid #edebe9;
}

.blockBreak {
  display: block !important;
  .d-flex {
    display: flex;
    max-width: 100%;
    justify-content: space-between;
    > .boxFormType {
      flex: 0 0 49%;
      max-width: 49%;
      align-self: flex-start;
    }
    &.threeFields {
      > .boxFormType {
        flex: 0 0 35%;
        max-width: 35%;
      }

      .unitSelect {
        flex: 0 0 24%;
        max-width: 24%;
      }
    }
  }
  .d-flex1 {
    display: flex;
    justify-content: space-between;
    > .boxFormType {
      flex: 0 0 49%;
      max-width: 49%;
      align-self: flex-start;
    }
    &.threeFields {
      > .boxFormType {
        flex: 0 0 35%;
        max-width: 35%;
      }

      .unitSelect {
        flex: 0 0 24%;
        max-width: 24%;
      }
    }
  }
  .boxFormType {
    margin-bottom: 18px;
  }
}
.justifyCSBetween {
  justify-content: space-between;
}
  .printSidePanel {
      width: 328px;
    height: 480px;
    left: 0px;
    top: 0px;
    padding: 10px;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    border: 1px solid #d2d0ce;
    // margin-bottom: 13px;
    background-color: #fff;
  }
  .paperCoverBg {
    // margin: 40px auto;
    padding-top: 80px;
    margin: 0 148px;
    text-align: center;
    img {
      width: 309.63px;
      height: 293px;
      margin-bottom: 24px;
    }
    p {
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #605e5c;
    }
  }
  .ListingPaperCovers {
    background-color: #faf9f8 !important;
    text-align: center;
    width: 328px;
    padding-bottom: 18px;
  }
  .leftListingPapeprMachines {
    //   width: 350px;
    // height: 40px;
    left: 0px;
    top: 0px;
    padding: 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    border: 1px solid #d2d0ce;
    // margin-bottom: 13px;
    background-color: #fff;
  }
  .leftListingPapeprMachines span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: var(--black-color);
    // overflow-y: hidden;

  }
  .rewindingCuttingBoxStyle {
    margin: 0 8px !important;
    background: #ffffff;
    border: 0px solid #d2d0ce;
    box-sizing: border-box;
    border-radius: 8px;
    // display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: space-around !important;
    align-items: center !important;
    padding: 6px 10px !important;
    margin-bottom: 14px !important;
    position: relative;
    p {
      margin-bottom: 0px;
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      display: flex;
      align-items: center;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 7px;
      
    }
    .rightBoxImage img {
      width: 80px;
    }
    .rightBoxTitle {
      text-align: left;
    }
  }
  
  .checkboxListingPapers {
    margin: 0 8px !important;
    background: #ffffff;
    border: 1px solid #d2d0ce;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    justify-content: space-around !important;
    align-items: center !important;
    padding: 15px 10px !important;
    margin-bottom: 14px !important;
    position: relative;
    p {
      margin-bottom: 0px;
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: var(--light-text);
    }
    .rightBoxImage img {
      width: 80px;
    }
    .rightBoxTitle {
      text-align: left;
    }
  }
  .ant-checkbox + span {
    display: none;
  }
  .ant-checkbox-inner {
    width: 24px;
    height: 24px;
    right: 16px;
    top: 4px;
    background: #ffffff;
    border: 1px solid #c8c6c4;
    box-sizing: border-box;
    border-radius: 15px;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ea655b;
    border-color: #ea655b;
  }
  .ant-checkbox-checked::after {
    border: 1px solid #ea655b;
    display: none;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border: 1px solid #ea655b;
  }
  .ant-checkbox-inner::after {
    left: 6px;
    height: 11.143px;
  }
  .ant-checkbox-input {
    position: absolute !important;
    opacity: 0;
    width: 100%;
  }
  .ant-checkbox {
    position: static !important;
  }

  .checkboxListingPapers-active {
    border: 3px solid #ea655b !important;
  }
`;
export const PaperMachineScroll = styled.div`
  overflow-y: scroll;
  cursor: pointer;
  height: calc(100vh - 230px);  
  //height:61vh;
  .cardRollers {
    flex: 1 1 auto;
    margin: 8px 4px;
    min-height: 0;
    // overflow-x: hidden;
    // overflow-y: auto;
    padding: 4px 4px;
    z-index: 1;
    .ant-card-body {
      padding: 8px;
    }
    .ant-card-bordered {
      border-color: #f9f9f9;
      margin-bottom: 12px;
      border-radius: 8px;
      cursor: pointer;
    }
  }
`;

export const PaperMachineQualitySelect = styled.div`
.ql-editor ul > li::before{
content:none;
}
.ql-editor ol, .ql-editor ul{
padding-left: 0px !important;
}
  .dropdown-heading-dropdown-arrow.gray {
    left: 0px;
    width: 7px;
    height: 7px;
    z-index: 5;
    border-top: 2px solid #605e5c;
    border-right: 2px solid #605e5c;
    transform: rotate(135deg);
  }
  .dropdown-search-clear-icon.gray {
    // width:7px;
    // height:7px;
  }
  .rmsc .dropdown-container:focus-within {
    box-shadow: 0;
    border-color: none;
  }
  .rmsc .dropdown-container {
    position: relative;
    outline: 0;
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    border-radius: var(--rmsc-radius);
    box-sizing: border-box;
    border-radius: 8px;
    height: 40px;
    font-size: 14px;
    font-family: var(--sf-pro-text);
    color: #323130;
    box-shadow: none !important;
    // width: 177px !important;
  }
  .rmsc .clear-selected-button {
    display: none !important;
  }
  .dropdown-heading-value {
    font-family: var(--sf-pro-text) !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .dropdown-content {
    font-family: var(--sf-pro-text) !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 20px !important;
    padding: 10px !important;
  }
`;
export const PaperMachineGradeSelect = styled.div`
  .mainMachineGrade {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .MachineGradeSelect {
    background: none;
  }
  .MachineGradeSelect-active {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 14px;
    background: #fdf0ef;
    border-radius: 25px;
    margin-bottom: 13px;
    // padding: 9px !important;
    color: #ea655b;
    margin-right: 12px;
  }
  .textTypeBtn.textBtnIcon.paperButtonBg {
    background-color: #fdf0ef !important;
  }
  .textTypeBtn {
    margin: 0px 2px 0 16px !important;
  }
  // .textTypeBtn{
  //   margin: 0px 22px !important;
  // }
`;

export const LandingPage = styled.div`
  .avatar {
    width: 32px;
    height: 32px;
    background-image: url(${userAvatar});
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 12px;
    margin-left: -14px;
    margin-top: 6px;
  }

  .landingHeader {
    padding: 28px 35px;
    border-bottom: 0;
  }
  .headerAvatarTitle {
    display: flex;
    span {
      font-family: var(--sf-pro-display);
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #000000;
    }
    p {
      font-family: var(--sf-pro-display);
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #ea655b;
    }
  }
  .rightSideModules {
    padding: 10px 35px;
    span {
      font-family: var(--sf-pro-display);
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #000000;
    }
    &_links {
      margin-top: 23px;
      span {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
        a {
          font-family: var(--sf-pro-text) !important;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: var(--color-text-title);
        }
      }
    }
  }
  .leftSideModules {
    // width: 1092px;
    // height: 590px;
    // left: 48px;
    // top: 178px;
    background: #f7f6f9;
    border-radius: 32px;
    padding: 10px;
  }
  .modulesList:hover {
    background: #ffffff;
    border-radius: 16px;
  }
  .modulesList:hover .modulesList_content span {
    color: var(--theme-color) !important;
  }
  .modulesList:hover .modulesList_image {
    background-color: var(--theme-color);
  }

  .modulesList {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 18px;
    // width: 264px;
    // height: 268px;
    left: 0;
    top: 0;
    margin: 12px;
    min-height: 276px;

    &_image {
      width: 96px;
      height: 96px;
      left: 0px;
      top: 0px;
      border: 2px solid #e1dfdd;
      box-sizing: border-box;
      border-radius: 16px;
      margin: 20px 0;
      display: flex;
      align-items: center;
      text-align: center;
      padding: 25px;
    }
    &_content {
      span {
        font-family: var(--sf-pro-display);
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: #000000;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 8px 0px;
      }
      p {
        font-family: var(--sf-pro-text) !important;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        color: var(--para-text) !important;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 8px 0px;
      }
    }
  }

  .modulesList_content span:hover {
    color: var(--theme-color) !important;
  }
  .rightMenuSection {
    position: fixed !important;
    z-index: 10 !important;
  }
  .rightSideModules_links span a:hover {
    color: var(--theme-color) !important;
  }

  // .modulesListMain {
  //   /* margin: 10px; */
  //   padding: 20px;
  // }
`;
export const PaperBlockList = styled.div`
  .removeStar {
    .ant-form-item-label {
      label {
        &:before {
          display: none !important;
        }
        &:after {
          display: none !important;
        }
      }
    }
  }
  .ant-form-item-label
    > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    display: none !important;
  }
  .ant-form-item-label > label::after {
    display: none !important;
  }
  .dBlock {
    display: block !important;
    .ant-form-item-label {
      label {
        color: var(--para-text);
        font-size: 12px;
        font-family: var(--sf-pro-text) !important;
        line-height: 1;
        height: 26px;
        padding: 0px 5px;
      }
    }
  }
  .boxFieldTitle.removeStar {
    label {
      height: 16px;
    }
  }
  .boxFieldTitle {
    padding-left: 25px;
  }
  .boxFieldTitleMulti {
    padding-left: 25px;
    p{
      padding-right: 55px;
      text-align: justify;
      text-justify: inter-word;
    }
  }
  .boxFieldTitleMulti.removeStar {
    label {
      height: 16px;
    }
    p{
      padding-right: 55px;
      text-align: justify;
      text-justify: inter-word;
    }
  }
  .boxFormType {
    align-self: center;
    width: 100%;
    .ant-select {
      width: 100%;
    }
    &:last-child {
      margin-bottom: 0px !important;
    }
  }

  label.floating-label {
    font-family: var(--sf-pro-text) !important;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #a19f9d;
  }

  span.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled {
    border-color: transparent !important;
    color: rgba(0, 0, 0, 0.25);
    background-color: #ebecf0;
    // border-color: #d9d9d9;
    box-shadow: none;
    cursor: not-allowed;
    opacity: 1;
    border-radius: 8px;
  }
  input#basic_effective_deckle_length {
    background-color: #ebecf0;
    padding-left: 4px !important;
  }
  input#basic_effective_deckle_length_cutter {
    background-color: #ebecf0;
    padding-left: 4px !important;
  }
`;

export const AlertDiv = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-top: 10px;
`;
export const TableList = styled.div`
  .listing-table {
    background: #ffffff;
    border: 1px solid #e1dfdd;
    box-sizing: border-box;
    border-radius: 8px;
    width: 8%;
    padding: 6px;
    display: flex;
    justify-content: space-between;
  }
  .table-view {
    display: flex;
    align-items: center;
  }
  .switchRadio .ant-radio-group-solid label {
    width: 50px !important;
  }
  .ant-radio-group.ant-radio-group-solid {
    // margin-right: 90px;
    margin-right: 0px !important;
  }
  .List-grid-View {
    // padding: 2px 12px;
    border-radius: 16px;
    align-self: flex-end;
    //margin: 9px 0px 0px 167px;
    .printIcon {
      display: flex;
      align-self: center;
      //margin: 0px 40px 0px 0px;
      cursor: pointer;
      padding-right: 10px;
      padding-bottom: 5px;
    }
  }
  .radioSwitchStyle {
    display: flex !important;
    justify-content: end !important;
    position: absolute !important;
    right: 0px !important;
    top: -51px !important;
  }
  &.job-switch {
    position: absolute;
    right: 218px;
    top: 23px;
    width: 100%;
    .radioSwitchStyle {
      top: 0px !important;
    }
  }
`;

export const RadioButtonStyle = styled.div`
  .switchRadio .ant-radio-group-solid label span:last-child {
    padding: 4px 0 !important;
  }
  .switchRadio .ant-radio-group-solid label {
    height: 30px !important;
    width: 50px !important;
    background: #ffffff !important;
    border: 1px solid #e1dfdd !important;
    svg {
      color: #a19f9d !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.gridViewActive label:first-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 8px 0px 0px 8px !important;
    border-right: 0 !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.ListViewActive label:last-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid label{
    span{
      font-family: var(--sf-pro-display) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.allActive label:first-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 8px 0px 0px 8px !important;
    // border-right: 0 !important;
    span {
      color: var(--theme-color) !important;
      font-family: var(--sf-pro-display) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.sheetActive label:last-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.jcActive label:nth-child(2) {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    // border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .setHeightPadding .ant-radio-group .ant-radio-button-wrapper{
    height: 35px!important;
    padding-inline: 1px !important;
  }
`;
export const RadioButtonStyle1 = styled.div`
  .switchRadio .ant-radio-group-solid label span:last-child {
    padding: 4px 0 !important;
  }
  .switchRadio .ant-radio-group-solid label {
    height: 30px !important;
    width: 50px !important;
    background: #ffffff !important;
    border: 1px solid #e1dfdd !important;
    svg {
      color: #a19f9d !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.gridViewActive label:first-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 8px 0px 0px 8px !important;
    border-right: 0 !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.ListViewActive label:last-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid label{
    span{
      font-family: var(--sf-pro-display) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.allActive label:first-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 8px 0px 0px 8px !important;
    // border-right: 0 !important;
    span {
      color: var(--theme-color) !important;
      font-family: var(--sf-pro-display) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.sheetActive label:last-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
    }
  }
  .ant-radio-group.ant-radio-group-solid.jcActive label:nth-child(2) {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    // border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
    }
  }

   label span:last-child {
    padding: 4px 0 !important;
  }
   label {
    height: 30px !important;
    width: 50px !important;
    background: #ffffff !important;
    border: 1px solid #e1dfdd !important;
    svg {
      color: #a19f9d !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .gridViewActive label:first-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 8px 0px 0px 8px !important;
    border-right: 0 !important;
    svg {
      color: var(--theme-color) !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  label:last-child{
    border-radius: 0px 8px 8px 0px !important;
  }
  .ListViewActive label:last-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
   label{
    span{
      font-family: var(--sf-pro-display) !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }
  .allActive label:first-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 8px 0px 0px 8px !important;
    // border-right: 0 !important;
    span {
      color: var(--theme-color) !important;
      font-family: var(--sf-pro-display) !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .sheetActive label:last-child {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .jcActive label:nth-child(2) {
    background: #f3f2f1 !important;
    border: 1px solid #a19f9d !important;
    box-sizing: border-box !important;
    // border-radius: 0px 8px 8px 0px !important;
    svg {
      color: var(--theme-color) !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .allActive, .sheetActive, .jcActive{
      display:flex;
  }
  label:first-child{
    border-radius: 8px 0px 0px 8px !important;
  }

  
`;

export const JobCardColorStatus = styled.div`
  display: flex;
  align-items: flex-end;
  .statusVal[dataval="Disabled"],
  .statusVal[dataval="Deactive"],
  .statusVal[dataval="hold"],
  .statusVal[dataval="rejected"],
  .statusVal[dataval="cancel"],
  .statusVal[dataval="under_review"] {
    color: #ea4e2c;
    background-color: #fdeeea;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    // margin: 0 55px 0 15px;
  }
  .statusVal[dataval="approved"],
  .statusVal[dataval="complete"] {
    color: #107c10;
    background-color: #ecf9f0;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    // margin: 0 45px 0 15px;
  }
  .statusVal[dataval="in_production"] {
    color: #107c10;
    background-color: #ecf9f0;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    // margin: 0 30px 0 15px;
  }
  .statusVal[dataval="pending"],
  .statusVal[dataval="active"] {
    color: #3485e0;
    background-color: #e3effc;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    margin: 0 auto;
  }
`;

export const RightSideSolution = styled.div`
  .rightSideSolutionButtons {
    display: flex;
    flex-direction: row;
  }
  .ant-pipe-container {
    width: 100%;
  }
  .main-container {
    width: 100% !important;
  }
  .deckleCoverImage {
    text-align: center;
  }
  .deckleCoverImage img {
    width: 317.63px;
    height: 293px;
    margin-bottom: 18px;
  }
`;
